import { render } from "./UploadedFiles.vue?vue&type=template&id=aa0421f8"
import script from "./UploadedFiles.vue?vue&type=script&lang=js"
export * from "./UploadedFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__